// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1hz-b","requiredAsterisk":"Info_requiredAsterisk__zv1xr"};